webpackJsonp([72776394686286],{

/***/ 215:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(35);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var newsPage = function newsPage(_ref) {
	  var data = _ref.data;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'section',
	      null,
	      _react2.default.createElement(
	        'header',
	        { className: 'news-header' },
	        _react2.default.createElement(
	          'h1',
	          null,
	          'News'
	        )
	      ),
	      data.allMarkdownRemark.edges.map(function (_ref2) {
	        var node = _ref2.node;
	        return _react2.default.createElement(
	          _gatsbyLink2.default,
	          { key: node.id, to: node.frontmatter.path },
	          _react2.default.createElement(
	            'div',
	            { className: 'news' },
	            _react2.default.createElement(
	              'p',
	              { className: 'date' },
	              node.frontmatter.date.substring(0, 10)
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'excerpt' },
	              node.excerpt
	            )
	          )
	        );
	      })
	    )
	  );
	};
	
	exports.default = newsPage;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-news-js-c6e7f76958c097f64dab.js